import React, { useState } from "react";
import styles from "./RefundRequestList.module.scss";
import { Col, Container, Row } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import ComponentBackButton from "../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import { useNavigate } from "react-router-dom";
import RefundRequestListComp from "../../../../components/AdminPortalComponents/Refund&DisputeManagement/RefundRequestList/RefundRequestList.comp";
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import DetailsCard from "../../../../components/common/AdminCommonComponents/DetailsCard/DetailsCard";

const orderFulfillmentData = [
    { title: "total refunds processed", value: 0 },
    { title: "Accepted requests", value: 0 },
    { title: "Rejected requests", value: 0 },
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));

const refundInfo = [
    {
        key: "Transaction ID:",
        value: "R-100"
    },
    {
        key: "Refund ID:",
        value: "R-100"
    },
    {
        key: "Order ID:",
        value: "R-100"
    },
    {
        key: "Customer Name:",
        value: "Full Name",
        color: true
    },
    {
        key: "Seller Name:",
        value: "Full Name",
        color: true
    },
    {
        key: "Refund Amount:",
        value: "$200",
        valColor: true
    },
    {
        key: "Request Date:",
        value: "Nov, 17 2090"
    },
    {
        key: "Status:",
        value: "Issued"
    },
]
const orderDetails = [
    {
        key: "Products name: ",
        value: "Product"
    },
    {
        key: "Purchase Date:",
        value: "10/10/2020"
    },


]


const RefundRequestList = () => {
    const [detailView, setDetailView] = useState(false)

    const navigate = useNavigate()
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Refund Request Summary</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>
            {!detailView &&
                <>
                    <Container fluid className={styles.filterTableWrapper}>
                        <div className="p-3 d-flex align-items-center justify-content-between">
                            <div className={`fw-semibold fs-4 ${styles.text} `}>Refund Requests</div>
                        </div>

                        <RefundRequestListComp setDetails={() => setDetailView(true)} />
                    </Container>
                </>}
            {detailView &&
                <Container fluid className={styles.orderWrapper}>
                    <ComponentBackButton onClick={() => setDetailView(false)} />
                    <div className={`fw-semibold text-center m-20 fs-4 ${styles.text} `}>Refund Request Detail</div>
                    <div className={`${styles.detailsContainer} container`}>
                        <Row className="row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-3">

                            <Col className=" d-grid">
                                <DetailsCard title={"Refund Information"}>
                                    {refundInfo.length > 0 && refundInfo.map((item, index) => {
                                        return (
                                            <div className={styles.cont}>
                                                <div className={item.color ? styles.blueText : styles.text1}>{item.key}</div>
                                                <div className={item.valColor ? styles.greenText : ""}>{item.value}</div>
                                            </div>

                                        )
                                    })}
                                </DetailsCard>
                            </Col>

                            <Col className=" d-grid">
                                <DetailsCard title={"Order Details"}>
                                    {orderDetails.length > 0 && orderDetails.map((item, index) => {
                                        return (
                                            <div className={styles.cont}>
                                                <div className={styles.text1}>{item.key}</div>
                                                <div>{item.value}</div>
                                            </div>

                                        )
                                    })}

                                    <div className={styles.border}>
                                        <div className={styles.cont}>
                                            <div className={styles.text1}>Payment Method:</div>
                                            <div>Debit Card</div>
                                        </div>

                                        <div className={styles.cont}>
                                            <div className={styles.text1}>Shipping Method:</div>
                                            <div>Standard</div>
                                        </div>
                                    </div>
                                </DetailsCard>
                            </Col>

                            <Col className=" d-grid">
                                <DetailsCard title={"Refund Reason"}>

                                    <div className={styles.cont}>
                                        <div className={styles.text1}>Customer Reason:</div>
                                        <div className={styles.redText}>Damaged</div>
                                    </div>

                                    <div className={styles.cont}>
                                        <div className={styles.text1}>Seller's Note:</div>
                                        <div></div>
                                    </div>


                                </DetailsCard>
                            </Col>

                            <Col className=" d-grid">
                                <DetailsCard titleColor={true} title={"Actions"}>
                                    <Row className="mt-4 gap-3">
                                        <DynamicButton theme="blue"   >Approve</DynamicButton>
                                        <DynamicButton outline theme="blue"   >Reject</DynamicButton>
                                    </Row>
                                    <div className={styles.underlineText}>Issue Store Credit</div>
                                </DetailsCard>
                            </Col>

                        </Row>
                    </div>


                </Container>
            }
        </div>
    );
};

export default RefundRequestList;